import { createContext, useReducer } from "react";
import { ConfigReducer } from "./ConfigReducer";



const configInitialState = {
    theme: 'light',
    language: 'es',
};


export const ConfigContext = createContext({});


export const ConfigProvider = ({children}) => { 
 
    const [config, dispatch] = useReducer(ConfigReducer, configInitialState, );

    const changeTheme = (theme) => {
        dispatch({type: 'changeTheme', payload: theme});
    }

    const changeLanguage = (language) => {
        dispatch({type: 'changeLanguage', payload: language});
    }

    const setConfig = (config) => {
        dispatch({type: 'setConfig', payload: config});
    }

    return (
        <ConfigContext.Provider value={{ 
            config,
            changeTheme,
            changeLanguage,
            setConfig
        }}>
            {children}
        </ConfigContext.Provider>
        );
};